import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import moment from "moment";
import { Modal } from "antd";
import {
    RiCheckboxCircleLine,
    RiAlertLine,
    RiInformationLine,
} from "react-icons/ri";
// Auth Related Methods
import {
    postAdd,
    getParamsList,
    postEdit,
    postDelete,
    getList,
    postFormData,
} from "../../../helpers/Helper";
import {
    apiError,
    refundListSuccessful,
    refundByIDSuccessful,
    isModelVisible,
    isRejectModelVisible,
    addrefundSuccessful,
    getrefundList,
    getrefundByID
} from "./refundSlice";

import { getrefundCheckApprove } from "./refundSlice"



function* getrefundLists({ payload }) {
    var data = payload;
    var params = {};
    for (const k in data) {
        if (Object.hasOwnProperty.call(data, k)) {
            if (k === "currentSort" || k === "sortOrder") {
                params.ordering = data.sortOrder + data.currentSort;
            } else {
                if (data[k] != "" && k != null && k != "no_of_pages") {
                    if (k == "start_date") {
                        params[k] = moment(data[k]).format("YYYY-MM-DD");
                    } else if (k == "end_date") {
                        params[k] = moment(data[k]).add(1, "days").format("YYYY-MM-DD");
                    } else {
                        params[k] = data[k];
                    }
                }
            }
        }
    }
    try {
        const response = yield call(getParamsList, "/accounts/advancerefundrequest/", params);
        console.log(response, "ooooooooooo")
        yield put(refundListSuccessful(response));
    } catch (error) {
        yield put(apiError(error));
    }
}


function* getrefundDataByID({ payload }) {
    try {
        const response = yield call(
            getParamsList,
            "/accounts/advancerefundrequest/" + payload.row.id,
            {}
        );
        yield put(refundByIDSuccessful({ response, type: payload.type }));
    } catch (error) {
        yield put(apiError(error));
    }
}


function* addrefund({ payload }) {
    try {
        if (payload.id === 0 || payload.id === null || payload.id === undefined) {
            const response = yield call(postAdd, "/accounts/advancerefundrequest/", payload);
            if (response.status === 201 || response.status === 200) {
                Modal.success({
                    icon: (
                        <span className="remix-icon">
                            <RiCheckboxCircleLine />
                        </span>
                    ),
                    title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
                    content: (
                        <div>
                            <p className="hp-p1-body hp-text-color-black-80">
                                Your Refund Added Successfully.!
                            </p>
                        </div>
                    ),
                });
                yield put(isModelVisible(false));
                yield put(getrefundList({ page: 1, search: "", page_size: 10 }));
                yield put(addrefundSuccessful(null))
            } else {
                Modal.error({
                    icon: (
                        <span className="remix-icon">
                            <RiAlertLine />
                        </span>
                    ),
                    title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
                    content: (
                        <div>
                            <p className="hp-p1-body hp-text-color-black-80">
                                Sorry! Unable to Do Refund. Please try again!
                            </p>
                        </div>
                    ),
                });
            }
        } else {
            const response = yield call(
                postEdit,
                "/accounts/advancerefundrequest/" + payload.id,
                payload
            );
            if (response.status === 200 || response.status === 201) {
                Modal.success({
                    icon: (
                        <span className="remix-icon">
                            <RiCheckboxCircleLine />
                        </span>
                    ),
                    title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
                    content: (
                        <div>
                            <p className="hp-p1-body hp-text-color-black-80">
                                Your Refund Edited Successfully.!
                            </p>
                        </div>
                    ),
                });
                yield put(isModelVisible(false));
                yield put(getrefundList({ page: 1, search: "", page_size: 10 }));
                yield put(addrefundSuccessful(null));


            } else {
                Modal.error({
                    icon: (
                        <span className="remix-icon">
                            <RiAlertLine />
                        </span>
                    ),
                    title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
                    content: (
                        <div>
                            <p className="hp-p1-body hp-text-color-black-80">
                                Sorry! Unable to edit Laon. Please try again!
                            </p>
                        </div>
                    ),
                });
            }
            // yield put(vehiclesAddSuccessful(null));
        }
    } catch (error) {

        const backendMessage =
            error.response && error.response.data && error.response.data.error
                ? error.response.data.error[0]
                : "Sorry! Getting from server side issue!";
        Modal.error({
            icon: (
                <span className="remix-icon">
                    <RiAlertLine />
                </span>
            ),

            title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
            content: (
                <div>
                    <p className="hp-p1-body hp-text-color-black-80">
                        {backendMessage}
                    </p>
                </div>
            ),
        });
        yield put(addrefundSuccessful(null));
        yield put(apiError(error));
    }
}



function* refundIdApproval({ payload }) {
    try {
        const response = yield call(postEdit, "/accounts/advancerefundapprove/" + payload.id, payload);
        if (response.status === 200) {
            if (payload.approval_status == 2) {
                Modal.success({
                    icon: (
                        <span className="remix-icon">
                            <RiCheckboxCircleLine />
                        </span>
                    ),
                    title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
                    content: (
                        <div>
                            <p className="hp-p1-body hp-text-color-black-80">
                                Your refund has been approved successfully.
                            </p>
                        </div>
                    ),
                });
            } else if (payload.approval_status == 3) {
                Modal.success({
                    icon: (
                        <span className="remix-icon">
                            <RiCheckboxCircleLine />
                        </span>
                    ),
                    title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
                    content: (
                        <div>
                            <p className="hp-p1-body hp-text-color-black-80">
                                Your refund has been Rejected successfully.
                            </p>
                        </div>
                    ),
                });
            }

            yield put(getrefundCheckApprove({ id: payload.refund_id }));
            yield put(isRejectModelVisible(false));
            yield put(getrefundByID({ row: { id: payload.id }, type: "view" }));

        } else {
            if (payload.approval_status == 2) {
                Modal.error({
                    icon: (
                        <span className="remix-icon">
                            <RiAlertLine />
                        </span>
                    ),
                    title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
                    content: (
                        <div>
                            <p className="hp-p1-body hp-text-color-black-80">
                                Sorry! Unable to Approve refund. Please try again!
                            </p>
                        </div>
                    ),
                });
            } else if (payload.approval_status == 3) {
                Modal.error({
                    icon: (
                        <span className="remix-icon">
                            <RiAlertLine />
                        </span>
                    ),
                    title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
                    content: (
                        <div>
                            <p className="hp-p1-body hp-text-color-black-80">
                                Sorry! Unable to Reject refund. Please try again!
                            </p>
                        </div>
                    ),
                });
            }
        }
    } catch (error) {
        Modal.error({
            icon: (
                <span className="remix-icon">
                    <RiAlertLine />
                </span>
            ),

            title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
            content: (
                <div>
                    <p className="hp-p1-body hp-text-color-black-80">
                        Sorry! Getting from server side issue!
                    </p>
                </div>
            ),
        });
        yield put(apiError(error));
    }
}

function* VehicleDataGet({ payload }) {
    try {
        const response = yield call(getList, "/masters/vehicles/" + payload, {});
        yield put(vehicleDataSuccessful({ response }));
    } catch (error) {
        yield put(apiError(error));
    }
}


function* refundIdDelete({ payload }) {
    try {
        const response = yield call(postDelete, "/accounts/advancerefundrequest/" + payload.id);

        if (response.status === 204) {
            Modal.success({
                icon: (
                    <span className="remix-icon">
                        <RiCheckboxCircleLine />
                    </span>
                ),
                title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
                content: (
                    <div>
                        <p className="hp-p1-body hp-text-color-black-80">
                            Your refund has been deleted!
                        </p>
                    </div>
                ),
            });

            yield put(getrefundList({ page: 1, search: "", page_size: 10 }));
        } else {
            Modal.error({
                icon: (
                    <span className="remix-icon">
                        <RiAlertLine />
                    </span>
                ),

                title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
                content: (
                    <div>
                        <p className="hp-p1-body hp-text-color-black-80">
                            Sorry! Your refund has been not deleted!
                        </p>
                    </div>
                ),
            });
        }
    } catch (error) {
        Modal.error({
            icon: (
                <span className="remix-icon">
                    <RiAlertLine />
                </span>
            ),

            title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
            content: (
                <div>
                    <p className="hp-p1-body hp-text-color-black-80">
                        Sorry! Getting from server side issue!
                    </p>
                </div>
            ),
        });
        yield put(apiError(error));
    }
}



function* watchGetrefundList() {
    yield takeEvery("refund/getrefundList", getrefundLists);
}
export function* watchGetrefundByID() {
    yield takeEvery("refund/getrefundByID", getrefundDataByID);
}

export function* watchAddrefund() {
    yield takeEvery("refund/addrefund", addrefund);
}
export function* watchrefundDelete() {
    yield takeEvery("refund/refundDelete", refundIdDelete);
}

export function* watchrefundApproval() {
    yield takeEvery("refund/refundApproval", refundIdApproval);
}

export function* watchGetVehicleData() {
    yield takeEvery("refund/getVehicleData", VehicleDataGet);
}
function* refundSaga() {
    yield all([
        fork(watchGetrefundList),
        fork(watchGetrefundByID),
        fork(watchAddrefund),
        fork(watchrefundApproval),
        fork(watchrefundDelete),
        fork(watchGetVehicleData),
    ]);
}

export default refundSaga;
